import { createStyles, makeStyles } from '@mui/styles';
import { STYLE } from '../../../../constants';

export const useStyles = makeStyles((theme: any) =>
  createStyles({
    modal: {
      '& .MuiDialog-paper': {
        borderRadius: '12px',
        maxWidth: 900,
        width: 900,
        height: 600,
        '@media (max-width: 900px)': {
          width: '100%',
          height: '100%',
          margin: '0px',
          borderRadius: '0px',
          maxHeight: '100%',
        },
      },
      '& .MuiModal-backdrop': {
        backgroundColor: STYLE.COLOR.MODAL_BACKDROP,
      },
    },
    modalTitle: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      fontSize: '18px !important',
      color: STYLE.COLOR.WHITE,
      lineHeight: '28px !important',
      fontWeight: '500 !important',
      backgroundColor: STYLE.COLOR.TEXT1,
    },
    closeIconParent: {
      height: '28px',
      width: '28px',
      padding: '0px !important',
      marginLeft: '16px',
    },
    modalContent: {
      padding: '0px !important',
      position: 'relative',
      overflowY: 'hidden !important' as any,
      backgroundColor: STYLE.COLOR.BLACK,
    },
    modalContentError: {
      backgroundColor: STYLE.COLOR.WHITE,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '16px !important',
    },
    webcam: {
      objectFit: 'cover',
    },
    modalActionsParent: {
      display: 'flex',
      justifyContent: 'center',
      position: 'absolute',
      bottom: '16px',
      left: '50%',
      transform: 'translateX(-50%)',
      borderRadius: '50px',
      padding: '8px 22px 8px 22px !important',
      backgroundColor: STYLE.COLOR.CAPTURE_BUTTONS_BACKGROUND_COLOR,
      boxShadow: STYLE.COLOR.CAPTURE_BUTTONS_BOX_SHADOW,
      backdropFilter: 'blur(9px)',
      '& > button + button': {
        marginLeft: '24px !important',
        '@media (max-width: 900px)': {
          marginLeft: '14px !important',
        },
      },
    },
    buttonsParent: {
      paddingRight: '12px !important',
    },
    proceedButton: {
      height: '44px !important',
      minWidth: '156px !important',
      '&.Mui-disabled': {
        color: `${STYLE.COLOR.WHITE} !important`,
        backgroundColor: `${STYLE.COLOR.ACCENT_PRIMARY} !important`,
        opacity: '1 !important',
      },
      '& .MuiCircularProgress-root': {
        color: `${STYLE.COLOR.WHITE} !important`,
      },
    },
    iconButton: {
      padding: '0px !important',
    },
    capturedImage: {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
    },
    retakeButton: {
      backgroundColor: 'transparent !important',
      color: `${STYLE.COLOR.WHITE} !important`,
      border: `1px solid ${STYLE.COLOR.WHITE} !important`,
      height: '44px !important',
      minWidth: '156px !important',
      '&.Mui-disabled': {
        color: `${STYLE.COLOR.WHITE} !important`,
        border: `1px solid ${STYLE.COLOR.WHITE} !important`,
        opacity: '1 !important',
      },
    },
    noAccessText: {
      fontSize: '18px',
      fontWeight: '600',
      lineHeight: '140%',
      color: STYLE.COLOR.ERROR,
      marginTop: 14,
      marginBottom: 4,
    },
    errorReasonsText: {
      fontSize: '14px',
      fontWeight: '400',
      lineHeight: '140%',
      color: STYLE.COLOR.TEXT2,
      paddingLeft: 36,
      paddingRight: 36,
      textAlign: 'center',
    },
    errorList: {
      marginTop: 12,
      paddingLeft: 20,
    },
    errorText: {
      fontSize: '14px',
      fontWeight: '400',
      lineHeight: '140%',
      color: STYLE.COLOR.TEXT1,
    },
    loadingContainer: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: '16px',
      padding: '30px 40px',
      borderRadius: '12px',
      zIndex: 1000,
    },
    convertingText: {
      color: STYLE.COLOR.WHITE,
      margin: 0,
      fontSize: '16px',
      fontWeight: 500,
    },
    activityIndicator: {
      color: STYLE.COLOR.WHITE,
    },
    faceValidationOverlay: {
      width: '230px',
      position: 'absolute',
      top: '50%',
      right: 0,
      transform: 'translateY(-50%)',
      display: 'flex',
      flexDirection: 'column',
      gap: '8px',
      padding: '12px',
      borderTopLeftRadius: '12px',
      borderBottomLeftRadius: '12px',
      background: 'rgba(255, 255, 255, 0.10)',
      backgroundBlendMode: 'plus-lighter',
      boxShadow:
        '-0.6px 1.5px 48px -12px rgba(0, 0, 0, 0.15), 0.119px -0.298px 9.52px 0 rgba(255, 255, 255, 0.15) inset, 0.069px -0.172px 4.76px 0 rgba(255, 255, 255, 0.15) inset',
      backdropFilter: 'blur(1px)',
      zIndex: 10,
      '@media (max-width: 900px)': {
        width: 'calc(100% - 32px)',
        position: 'absolute',
        top: '16px',
        left: '16px',
        transform: 'none',
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: '8px',
        padding: '12px',
        borderRadius: '12px',
      },
    },
    faceValidationItem: {
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      padding: '4px 8px',
      borderRadius: '4px',
      backgroundColor: 'rgba(0, 0, 0, 0.50)',
    },
    faceValidationLabel: {
      fontSize: '12px',
      fontWeight: 400,
      lineHeight: '18px',
      color: STYLE.COLOR.WHITE,
    },
    faceOvalGuide: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: '240px',
      aspectRatio: '7/9',
      borderRadius: '50%',
      border: '3px solid',
      boxShadow: '0 0 0 9999px rgba(0, 0, 0, 0.35)',
      pointerEvents: 'none' as const,
      zIndex: 9,
      '@media (min-width: 501px) and (max-width: 900px)': {
        width: '45vw',
        top: '55%',
      },
      '@media (max-width: 500px)': {
        width: '65vw',
        top: '55%',
      },
    },
    faceOvalGuidePass: {
      borderColor: STYLE.COLOR.SUCCESS,
    },
    faceOvalGuideFail: {
      borderColor: STYLE.COLOR.ERROR,
    },
    faceOvalGuidePending: {
      borderColor: STYLE.COLOR.WHITE,
    },
  }),
);
